import "./style.scss";
import { useContext, useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import {
  AppSpan,
  AppText,
  Button,
  Circle,
  FixedContainer,
  FlexColumn,
  FlexRow,
  GridContainer,
  MenuIcon,
  FloatingContainer,
  FormGroupWithIcon,
} from "src/style";
import { Logo } from "src/assets/icons";
import VisibilityContext from "src/provider/state-manager/visibilityProvider";
import AppInfoContext from "src/provider/state-manager/appInfoProvider";
import ApiContext from "src/provider/API/call-service";
import { LogoutUI, RemoteUser } from "src/popup";
import { HiOutlineChevronDoubleRight } from "react-icons/hi";
import { BsBell } from "react-icons/bs";
import { AccountAction, AdminMenu } from "src/component";
import UserPics from "src/assets/img/rhydhur_pic.jpg";
import { OptionType, QoreStaffTypes, UserTypes } from "src/model";
import helpers from "src/utils/helpers";
import { FiChevronDown } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import * as IoIcons from "react-icons/io";

export const Header: React.FC = () => {
  const navigate = useNavigate();
  const { API } = useContext(ApiContext);
  const { visibility, showSideBar } = useContext(VisibilityContext);
  const {
    info: { sidebarMenuType, userType, role, qoreStaffType },
    setInfoProperty,
  } = useContext(AppInfoContext);
  const [navType, setNavType] = useState("");
  const [user, setUser] = useState({ userType, role });
  const [view, setView] = useState("");
  const { t } = useTranslation();

  //update biller gateway
  const [showBillers, setShowBillers] = useState(false);
  const [allInstitutions, setAllInstitutions] = useState<any>([]);
  const [gateWays, setGateWays] = useState<any>([]);
  const [selectedGateway, setSelectedGateway] = useState("");
  const [showSurvey, setShowSurvey] = useState(false);

  //update bank list
  const [showTransferGateways, setShowTransferGateways] = useState(false);
  const [transferGateway, setTransferGateway] = useState<any>([]);
  const [selectedTransferGateway, setSelectedTransferGateway] = useState("");
  const institutionTransfer = useMemo(
    () =>
      allInstitutions?.find(
        (institution: any) =>
          institution?.transferGateway === selectedTransferGateway
      ),
    [allInstitutions, selectedTransferGateway]
  );

  const gatewayInstitution = useMemo(
    () =>
      allInstitutions?.find(
        (institution: any) =>
          institution?.billsPaymentGateway === selectedGateway
      ),
    [allInstitutions, selectedGateway]
  );

  let menuWithNoSubMenu = [
    "institutions",
    "users",
    "faqs",
    "survey-report",
    "survey-management",
  ];
  let adminUsers = [UserTypes.ADMIN, UserTypes.USER];

  async function handleFetchInstitution() {
    const response = await API.getAllInstitutions();
    if (response?.length)
      setAllInstitutions(helpers.sortItemsWIthString(response, "name", "asc"));
  }

  useEffect(() => {
    if (!adminUsers.includes(user.userType)) {
      handleFetchInstitution();
    }

    if (sidebarMenuType) setNavType(sidebarMenuType);
  }, [sidebarMenuType]);

  const gatewayOptions = useMemo(() => {
    if (!allInstitutions) return [];

    const gateway = new Set();
    const options: OptionType[] = [];

    allInstitutions.forEach((institution: any) => {
      const billsPaymentGateway = institution?.billsPaymentGateway;
      if (billsPaymentGateway && !gateway.has(billsPaymentGateway)) {
        gateway.add(billsPaymentGateway);
        options.push({
          label: billsPaymentGateway,
          value: billsPaymentGateway,
        });
      }
    });

    return options;
  }, [allInstitutions]);

  const transferGateways = useMemo(() => {
    if (!allInstitutions) return [];

    const transfers = new Set();
    const options: OptionType[] = [];

    allInstitutions.forEach((institution: any) => {
      const transferGateway = institution?.transferGateway;
      if (transferGateway && !transfers.has(transferGateway)) {
        transfers.add(transferGateway);
        options.push({
          label: transferGateway,
          value: transferGateway,
        });
      }
    });

    return options;
  }, [allInstitutions]);

  useEffect(() => {
    setGateWays(gatewayOptions);
    setTransferGateway(transferGateways);
  }, [gatewayOptions, transferGateways]);

  useEffect(() => {
    setUser({ userType, role });
  }, [userType, role]);

  function handleMenuType(type: string) {
    setNavType(type);
    setInfoProperty("sidebarMenuType", type);

    if (menuWithNoSubMenu.includes(type)) {
      navigate(`/dashboard/${type}`);
    }
  }

  const updateBillsPayment = async (
    institutionCode: number,
    gateway: string
  ) => {
    const response = await API.updateBillsPayment(institutionCode, gateway);
    if (response) {
      setShowBillers(false);
    }
  };

  const updateBankList = async (institutionCode: number) => {
    const response = await API.updateBankList(institutionCode);
    if (response) {
      setShowTransferGateways(false);
    }
  };

  const institutionIdAndName = allInstitutions.map((item: any) => ({
    id: item.id,
    name: item.name,
    alias: item.alias,
  }));

  return (
    <>
      <MenuIcon onClick={() => showSideBar(!visibility.isSideBar)} />
      <FixedContainer
        top="0"
        left="0"
        width="100"
        sizeUnit="%"
        className="header-fix-container"
        zIndex="3"
      >
        <FlexColumn
          height="8"
          bgColor="#ffffff"
          leftPadding="10"
          rightPadding="10"
          className="header-wrapper"
        >
          <FlexRow justifyContent="space-between">
            <FlexRow justifyContent="flex-start" width="auto" sizeUnit="">
              <Logo className="header-logo" />
              {/* <AppText
                    color='#667085' textSize="1.6" fontWeight="600" leftMargin="3.5"
                     className="header-label"
                            >
                                Client Mobile & Internet Banking Setup
                            </AppText> */}
              <FlexRow
                leftMargin="3.5"
                gap="1"
                width="auto"
                sizeUnit=""
                className="admin-menu"
              >
                {adminUsers.includes(user.userType) ? (
                  <>
                    <GridContainer
                      minWidth="15"
                      radius="0.6"
                      height="5"
                      padding="0.5"
                      bgColor={
                        navType === "appConfig" ? "#E7F6F5" : "transparent"
                      }
                      onClick={() => handleMenuType("appConfig")}
                      className="menu-type-toggle"
                    >
                      <AppSpan
                        fontWeight="600"
                        cursor="pointer"
                        color={navType === "appConfig" ? "#0D968F" : "#667085"}
                      >
                        {t("header.app")}
                      </AppSpan>
                    </GridContainer>
                    <GridContainer
                      minWidth="16"
                      radius="0.6"
                      height="5"
                      padding="0.5"
                      bgColor={
                        navType === "feedManagement" ? "#E7F6F5" : "transparent"
                      }
                      onClick={() => handleMenuType("feedManagement")}
                      className="menu-type-toggle"
                    >
                      <AppSpan
                        fontWeight="600"
                        cursor="pointer"
                        color={
                          navType === "feedManagement" ? "#0D968F" : "#667085"
                        }
                      >
                        {t("header.feed")}
                      </AppSpan>
                    </GridContainer>
                    <GridContainer
                      width="7.8"
                      radius="0.6"
                      height="3.6"
                      padding="0.5"
                      bgColor={
                        navType === "reports" ? "#E7F6F5" : "transparent"
                      }
                      onClick={() => handleMenuType("reports")}
                      className="menu-type-toggle"
                    >
                      <AppSpan
                        fontWeight="600"
                        cursor="pointer"
                        color={navType === "reports" ? "#0D968F" : "#667085"}
                      >
                        {t("header.report")}
                      </AppSpan>
                    </GridContainer>
                    <GridContainer
                      width="9.0"
                      radius="0.6"
                      height="3.6"
                      padding="0.5"
                      bgColor={
                        navType === "customers" ? "#E7F6F5" : "transparent"
                      }
                      onClick={() => handleMenuType("customers")}
                      className="menu-type-toggle"
                    >
                      <AppSpan
                        fontWeight="600"
                        cursor="pointer"
                        color={navType === "customers" ? "#0D968F" : "#667085"}
                      >
                        {t("header.customer")}
                      </AppSpan>
                    </GridContainer>
                  </>
                ) : (
                  <>
                    <GridContainer
                      width="10.1"
                      radius="0.6"
                      height="3.6"
                      bgColor={
                        navType === "institutions" ? "#E7F6F5" : "transparent"
                      }
                      onClick={() => handleMenuType("institutions")}
                      className="menu-type-toggle"
                    >
                      <AppSpan
                        fontWeight="600"
                        cursor="pointer"
                        color={
                          navType === "institutions" ? "#0D968F" : "#667085"
                        }
                      >
                        {t("header.institution")}
                      </AppSpan>
                    </GridContainer>
                  </>
                )}
                <GridContainer
                  minWidth="9"
                  radius="0.6"
                  height="3.6"
                  bgColor={navType === "audit" ? "#E7F6F5" : "transparent"}
                  onClick={() => handleMenuType("audit")}
                  className="menu-type-toggle"
                >
                  <AppSpan
                    fontWeight="600"
                    cursor="pointer"
                    color={navType === "audit" ? "#0D968F" : "#667085"}
                  >
                    {t("header.audit")}
                  </AppSpan>
                </GridContainer>
                <GridContainer
                  minWidth="6.2"
                  radius="0.6"
                  height="3.6"
                  bgColor={navType === "users" ? "#E7F6F5" : "transparent"}
                  onClick={() => handleMenuType("users")}
                  className="menu-type-toggle"
                >
                  <AppSpan
                    fontWeight="600"
                    cursor="pointer"
                    color={navType === "users" ? "#0D968F" : "#667085"}
                  >
                    {t("header.user")}
                  </AppSpan>
                </GridContainer>
                <GridContainer
                  width="6.2"
                  radius="0.6"
                  height="3.6"
                  padding="0.5"
                  bgColor={navType === "faqs" ? "#E7F6F5" : "transparent"}
                  onClick={() => handleMenuType("faqs")}
                  className="menu-type-toggle"
                >
                  <AppSpan
                    fontWeight="600"
                    cursor="pointer"
                    color={navType === "faqs" ? "#0D968F" : "#667085"}
                  >
                    {t("header.faq")}
                  </AppSpan>
                </GridContainer>
                {userType === UserTypes.SUPER_ADMIN && (
                  <>
                    <GridContainer
                      width="8"
                      radius="0.6"
                      height="3.6"
                      bgColor={
                        navType === "configuration" ? "#E7F6F5" : "transparent"
                      }
                      onClick={() => handleMenuType("configuration")}
                      className="menu-type-toggle"
                    >
                      <AppSpan
                        fontWeight="600"
                        cursor="pointer"
                        color={
                          navType === "configuration" ? "#0D968F" : "#667085"
                        }
                      >
                        {t("header.config")}
                      </AppSpan>
                    </GridContainer>

                    <GridContainer
                      width="10.5"
                      radius="0.6"
                      height="3.6"
                      bgColor={
                        navType === "survey-management" ||
                        navType === "survey-report"
                          ? "#E7F6F5"
                          : "transparent"
                      }
                      // onClick={() => handleMenuType("survey")}
                      onClick={() => setShowSurvey(!showSurvey)}
                      className="menu-type-toggle"
                      style={{ marginLeft: 20 }}
                    >
                      <AppSpan
                        fontWeight="600"
                        cursor="pointer"
                        color={
                          navType === "survey-management" ||
                          navType === "survey-report"
                            ? "#0D968F"
                            : "#667085"
                        }
                      >
                        <FlexRow gap="0.5" alignItems="center">
                          {t("header.survey.title")}
                          {showSurvey ? (
                            <IoIcons.IoIosArrowUp />
                          ) : (
                            <IoIcons.IoIosArrowDown />
                          )}
                        </FlexRow>
                      </AppSpan>
                    </GridContainer>
                    {showSurvey && (
                      <FloatingContainer
                        left={"420px"}
                        top={"60px"}
                        width="15rem"
                        height="13rem"
                      >
                        <FlexColumn
                          bgColor="#FFFFFF"
                          padding="1.5"
                          radius="0.8"
                        >
                          <GridContainer
                            width="14"
                            radius="0.6"
                            height="3.6"
                            bgColor={
                              navType === "survey-management"
                                ? "#E7F6F5"
                                : "transparent"
                            }
                            onClick={() => {
                              handleMenuType("survey-management");
                              setShowSurvey(false);
                            }}
                            className="menu-type-toggle"
                          >
                            <AppSpan
                              fontWeight="600"
                              cursor="pointer"
                              color={
                                navType === "survey-management"
                                  ? "#0D968F"
                                  : "#667085"
                              }
                            >
                              <FlexRow gap="0.5" alignItems="center">
                                {t("header.survey.management")}
                              </FlexRow>
                            </AppSpan>
                          </GridContainer>

                          <GridContainer
                            width="14"
                            radius="0.6"
                            height="3.6"
                            topMargin="1"
                            bgColor={
                              navType === "survey-report"
                                ? "#E7F6F5"
                                : "transparent"
                            }
                            onClick={() => {
                              handleMenuType("survey-report");
                              setShowSurvey(false);
                            }}
                            className="menu-type-toggle"
                          >
                            <AppSpan
                              fontWeight="600"
                              cursor="pointer"
                              color={
                                navType === "survey-report"
                                  ? "#0D968F"
                                  : "#667085"
                              }
                            >
                              <FlexRow gap="0.5" alignItems="center">
                                {t("header.report")}
                              </FlexRow>
                            </AppSpan>
                          </GridContainer>
                        </FlexColumn>
                      </FloatingContainer>
                    )}

                    {qoreStaffType === QoreStaffTypes.DEVELOPER && (
                      <GridContainer
                        width="11"
                        radius="0.6"
                        height="3.6"
                        bgColor={
                          navType === "migration" ? "#E7F6F5" : "transparent"
                        }
                        onClick={() => {
                          setNavType("migration");
                          setInfoProperty("sidebarMenuType", "migration");
                          navigate("/dashboard/run-migration");
                        }}
                        className="menu-type-toggle"
                      >
                        <AppSpan
                          fontWeight="600"
                          cursor="pointer"
                          color={
                            navType === "migration" ? "#0D968F" : "#667085"
                          }
                        >
                          {t("header.migration")}
                        </AppSpan>
                      </GridContainer>
                    )}
                  </>
                )}
              </FlexRow>

              <FlexRow
                gap="0.5"
                width="auto"
                alignItems="center"
                sizeUnit=""
                leftMargin="1.5"
                className="admin-menu-toggle"
                style={{ zIndex: 3 }}
                onClick={() => setView("admin-menu")}
              >
                <AppText
                  textSize="1.7"
                  fontWeight="600"
                  color="#25282B"
                  cursor="pointer"
                  hoverColor="#0D968F"
                >
                  {t("header.admin")}
                </AppText>
                <AppSpan
                  textSize="2"
                  color="#0D968F"
                  cursor="pointer"
                  bottomMargin="0.5"
                >
                  <HiOutlineChevronDoubleRight />
                </AppSpan>
              </FlexRow>
            </FlexRow>
            <FlexRow
              width="auto"
              sizeUnit=""
              justifyContent="flex-start"
              gap="2.5"
            >
              {/*Biller Gateway*/}
              {!adminUsers.includes(user.userType) && (
                <Button
                  width="22"
                  titleSize="1.4"
                  fontWeight="600"
                  height="4"
                  radius="0.8"
                  color="#344054"
                  bgColor="#fff"
                  borderColor="#D0D5DD"
                  className="update-billers-btn"
                  onClick={() => setShowBillers(!showBillers)}
                  // onClick={() => API.updateBillsPayment()}
                >
                  {t("header.biller")}
                </Button>
              )}
              {showBillers && (
                <FloatingContainer left={"-180px"}>
                  <FormGroupWithIcon bottomMargin="0" topMargin="2">
                    <label>{t("header.billerSelect.title")}</label>
                    <div
                      style={{ height: "4rem", backgroundColor: "#F9FAFB" }}
                      className="input-with-icon"
                    >
                      <select
                        name={"billerGateway"}
                        value={selectedGateway}
                        onChange={(e: any) =>
                          setSelectedGateway(e.target.value)
                        }
                      >
                        <option value="">
                          {t("header.billerSelect.option")}
                        </option>
                        {gateWays?.map((gateway: any, index: number) => {
                          return (
                            <option key={index} value={gateway.value}>
                              {gateway?.label}
                            </option>
                          );
                        })}
                      </select>
                      <FiChevronDown className="input-with-icon-tag" />
                    </div>
                  </FormGroupWithIcon>
                  {selectedGateway && (
                    <>
                      {/* <FlexColumn
                        bgColor="#E7F6F5"
                        padding="1"
                        radius="0.8"
                        topMargin="2"
                        alignItems="center"
                        wrap="wrap"
                      >
                        <AppText size="1.2" color="#0D968F" fontWeight="600">
                          {`Institution with Gateway: ${gatewayInstitution?.name}`}
                        </AppText>
                      </FlexColumn> */}

                      <FlexColumn alignItems="flex-end" topMargin="2">
                        <Button
                          width="12"
                          onClick={() => {
                            updateBillsPayment(
                              Number(gatewayInstitution?.id),
                              gatewayInstitution?.transferGateway
                            );
                          }}
                        >
                          {t("header.billerSelect.button")}
                        </Button>
                      </FlexColumn>
                    </>
                  )}
                </FloatingContainer>
              )}

              {!adminUsers.includes(user.userType) && (
                <Button
                  width="22.5"
                  titleSize="1.4"
                  fontWeight="600"
                  height="4"
                  radius="0.8"
                  color="#344054"
                  bgColor="#fff"
                  borderColor="#D0D5DD"
                  className="update-billers-btn"
                  onClick={() => setShowTransferGateways(!showTransferGateways)}
                  // onClick={() => API.updateBillsPayment()}
                >
                  {t("header.bank")}
                </Button>
              )}
              {showTransferGateways && (
                <FloatingContainer left={"50px"}>
                  <FormGroupWithIcon bottomMargin="0" topMargin="2">
                    <label>{t("header.bankSelect.title")}</label>
                    <div
                      style={{ height: "4rem", backgroundColor: "#F9FAFB" }}
                      className="input-with-icon"
                    >
                      <select
                        name={"transferGateway"}
                        value={selectedTransferGateway}
                        onChange={(e: any) =>
                          setSelectedTransferGateway(e.target.value)
                        }
                      >
                        <option value="">
                          {t("header.bankSelect.option")}
                        </option>
                        {transferGateway?.map(
                          (transfer: any, index: number) => {
                            return (
                              <option key={index} value={transfer.value}>
                                {transfer?.label}
                              </option>
                            );
                          }
                        )}
                      </select>
                      <FiChevronDown className="input-with-icon-tag" />
                    </div>
                  </FormGroupWithIcon>
                  {selectedTransferGateway && (
                    <>
                      {/* <FlexColumn
                        bgColor="#E7F6F5"
                        padding="1"
                        radius="0.8"
                        topMargin="2"
                        alignItems="center"
                        wrap="wrap"
                      >
                        <AppText size="1.2" color="#0D968F" fontWeight="600">
                          {`Institution with Gateway: ${gatewayInstitution?.name}`}
                        </AppText>
                      </FlexColumn> */}

                      <FlexColumn alignItems="flex-end" topMargin="2">
                        <Button
                          width="15"
                          onClick={() => {
                            updateBankList(Number(institutionTransfer?.id));
                          }}
                        >
                          {t("header.bankSelect.button")}
                        </Button>
                      </FlexColumn>
                    </>
                  )}
                </FloatingContainer>
              )}

              <AppSpan textSize="2.4">
                <BsBell />
              </AppSpan>
              <Circle
                size="4"
                bgColor="#F9FAFB"
                style={{ overflow: "hidden" }}
                onClick={() => setView("account-action")}
              >
                <img src={UserPics} className="ads-img" />
              </Circle>
            </FlexRow>
          </FlexRow>
        </FlexColumn>
      </FixedContainer>
      {view === "logout-UI" && <LogoutUI close={() => setView("")} />}
      {view === "admin-menu" && <AdminMenu close={() => setView("")} />}
      {view === "remote-user" && <RemoteUser close={() => setView("")} />}
      {view === "account-action" && (
        <AccountAction
          close={() => setView("")}
          switchRemote={() => setView("remote-user")}
        />
      )}
    </>
  );
};
